import type { ITranslations } from '@inter-ikea-kompis/core/types'

import { isKeyOf } from '@sofa-platform/types'

import masterCopy from './master-copy.json' with { type: 'json' }

export type SofaTranslation = Record<SofaTranslationKey, string>

export type TranslationKey = SofaTranslationKey | KompisTranslationKey

export type SofaTranslationKey = keyof RawSofaTranslation

export type KompisTranslationKey = keyof ITranslations['kompis']

type RawSofaTranslation = typeof masterCopy

export function isSofaTranslationKey(key: TranslationKey): key is SofaTranslationKey {
  return isKeyOf(key, masterCopy)
}

export function getKompisTranslationByKey(path: KompisTranslationKey, obj?: object): string {
  if (!obj) {
    return path
  }

  return _getTranslationByPath(path, obj)
}

export function getTranslationByKey(path: SofaTranslationKey, obj?: object): string {
  if (!obj) {
    return masterCopy[path].message
  }
  return _getTranslationByPath(path, obj)
}

function _getTranslationByPath(path: TranslationKey, obj: object): string {
  const keys = path.split('.')
  // dynamic path traversal requires any
  // oxlint-disable-next-line typescript/no-explicit-any
  let acc: any = obj

  for (const k of keys) {
    if (acc == null) break
    acc = acc[k]
  }

  if (typeof acc !== 'string') {
    if (isKeyOf(path, masterCopy)) return masterCopy[path].message
    // Fallback to key in case of missing translation
    return path
  }
  return acc
}
